module.exports = __webpack_public_path__ + "static/media/sense4067.8c0278f8.jpg";